import { createFileRoute, Navigate } from '@tanstack/react-router';
import React from 'react';

import { isGameplayHistoryReplayEnabled } from '~/app/config';
import { ROUTE_404 } from '~/app/routes';
import SnapshotsPage from '~/pages/snapshots/index';

export const Route = createFileRoute('/snapshots/')({
  component: SnapshotsRoute,
});

function SnapshotsRoute() {
  if (!isGameplayHistoryReplayEnabled) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <SnapshotsPage />;
}
